import gql from 'graphql-tag'

export const insertBanner = ({ bannerData, bannerRoles }) => {
	return {
		mutation: gql`
			mutation ($banner: banners_insert_input!) {
				insert_banners_one(object: $banner) {
					id
				}
			}
		`,
		variables: {
			banner: {
				...bannerData,
				banners_roles: {
					data: bannerRoles.map(rol => ({
						rol_id: rol.id
					}))
				}
			}
		}
	}
}
